import React from 'react';
import '../scss/_authLoader.scss';

const AuthLoader = ({ isVisible }) => {
    if (!isVisible) return null;

    return (
        <div className="auth-loader-overlay">
            <div className="auth-loader-container">
                <div className="auth-loader-spinner"></div>
                <h3 className="auth-loader-title">Authenticating...</h3>
                <p className="auth-loader-text">Please wait while we verify your wallet</p>
            </div>
        </div>
    );
};

export default AuthLoader;
